/* eslint-disable max-len */
import PropTypes from 'prop-types';
// import _ from 'lodash';

import { Box, Container, Grid } from '@material-ui/core';

import { withTheme } from '@material-ui/core/styles';
// import debug from '../../services/debug';

import ErrorMessage from '../error-message/component';
import LogoIcon from '../../theme/styled-components/LogoIcon';

function MobileLoginProblem({ classes }) {
  // SWP-52: also shown in a browser, where there is no app to restart.
  const fix =
    window.ReactNativeWebView !== undefined
      ? 'Please restart the Saltus app to resolve the issue.'
      : 'Please refresh the webpage to resolve the issue.';

  return (
    <Box>
      <Grid container className={classes.root}>
        <Container maxWidth="lg">
          <LogoIcon />
          <ErrorMessage
            icon="error"
            error={{
              errors: [
                {
                  message: `Sorry, there has been a temporary issue accessing your account. ${fix}`,
                },
              ],
            }}
          />
        </Container>
      </Grid>
    </Box>
  );
}

MobileLoginProblem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object,
};

MobileLoginProblem.defaultProps = {
  classes: {},
};

export default withTheme(MobileLoginProblem);
